import { render, staticRenderFns } from "./OrganizationRestrictedAccessPanel.vue?vue&type=template&id=eab9c2ea&"
import script from "./OrganizationRestrictedAccessPanel.vue?vue&type=script&lang=js&"
export * from "./OrganizationRestrictedAccessPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports